import React from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { ScreenSizeNotSupportedPage } from 'common/components';
import { OverviewPage } from '../overview';

/**
 * The following routes exist here:
 *  overview:     https://path.to.psa.replicon.com/cost-price-optimizer/overview
 */
const OverviewRouteProxy: React.FC = () => {
  const { url } = useRouteMatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (isMobile) {
    return <ScreenSizeNotSupportedPage />;
  }

  return (
    <Switch>
      <Route path={`${url}/`} exact component={OverviewPage} />
    </Switch>
  );
};

export default OverviewRouteProxy;
